import React, { useState, useRef, useEffect } from "react";
import { ChartType, CHART_TYPE_LABELS, CHART_TYPE_ICONS } from "./analyticsState";

interface Props {
  onAddChart: (type: ChartType) => void;
  onBack: () => void;
  isDark: boolean;
  isDisabled?: boolean;
}

const CHART_GROUPS: { label: string; types: ChartType[] }[] = [
  { label: "Charts", types: ["bar", "line", "area", "pie", "donut", "radar"] },
  { label: "Advanced", types: ["scatter", "heatmap", "treemap", "funnel", "radialBar"] },
  { label: "Widgets", types: ["scorecard", "table", "text", "image"] },
];

const Toolbar: React.FC<Props> = ({
  onAddChart, onBack, isDark, isDisabled
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="ca-toolbar">
      <div className="ca-toolbar-left">
        <button className="ca-back-btn" onClick={onBack}>
          <i className="fa fa-arrow-left" /> Back
        </button>
        <span className="ca-toolbar-title">Custom Analytics</span>
      </div>

      <div className="ca-toolbar-right">
        <div className="ca-dropdown mx-3" ref={dropdownRef}>
          <button className="ca-btn ca-btn-primary" onClick={() => setOpen(!open)} disabled={isDisabled}>
            <i className="fa fa-plus" /> Add Chart
          </button>
          {open && (
            <div className="ca-dropdown-menu">
              {CHART_GROUPS.map((group, gi) => (
                <React.Fragment key={gi}>
                  <div className="ca-dropdown-section">{group.label}</div>
                  {group.types.map((t) => (
                    <button
                      key={t}
                      className="ca-dropdown-item"
                      onClick={() => { onAddChart(t); setOpen(false); }}
                    >
                      <i className={`fa ${CHART_TYPE_ICONS[t]}`} />
                      {CHART_TYPE_LABELS[t]}
                    </button>
                  ))}
                  {gi < CHART_GROUPS.length - 1 && <div className="ca-dropdown-divider" />}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Toolbar;
